import { AccountSetupStepEnum } from "enums/account-setup-step.enum";

export const ACCOUNT_SETUP_STEPS_ORDER: AccountSetupStepEnum[] = [
  AccountSetupStepEnum.BASIC_INFO,
  AccountSetupStepEnum.BUSINESS_INFO,
  AccountSetupStepEnum.OFFICES,
];
